import { useQuery } from "react-query";
import { showBudgetOrderDetails } from "Requests/Partners/PreBudgets";

export const usePreOrderDetails = (id: number) => {
  return useQuery({
    queryFn: () => showBudgetOrderDetails(Number(id)),
    queryKey: ["pre-order-detail-convertion", id],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1,
    enabled: !!id,
  });
};
